import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import InsuranceService from 'services/InsuranceService';
import { formatValidationErrors } from 'utils/ArrayUtils';

export const initialState = {
    list : [],
    fetching: false,
    creating: false,
    updating : false,
    deleting : false,
    errorMessages: [],
    showMessage: false,
    showEditForm : false,
    showNewForm : false,
}

export const fetchInsurances = createAsyncThunk('/fetchInsurances', async (data, {rejectWithValue }) => {
    try {
            const response = await InsuranceService.fetch();
            var code = response.code;	
            return {
                code: code,
                insurances : response.data
            };
    } catch (err) {
        let code = err.response?.data.code;
        let response = err.response;
        return rejectWithValue({
            code: code,
            errorMessages: response?.data?.message || 'Error'
        });
    }
});

export const createInsurance = createAsyncThunk('/createInsurance',async (data, { rejectWithValue }) => {
    try {
        const response = await InsuranceService.create(data)
        const code  = response.original.code;
        return {
            code: code,
            insurances : response.original.data
        };
    } catch (err) {
        return rejectWithValue({code : err.response.status, error : err.response?.data.errors} || {error : "Error creating a Insurance"})
    }
})

export const updateInsurance = createAsyncThunk('/updateInsurance',async (data, { rejectWithValue }) => {
    try {
        const response = await InsuranceService.update(data)
        const code = response.original.code;
        return {
            code: code,
            insurances : response.original.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const deleteInsurance = createAsyncThunk('/deleteInsurance',async (id, { rejectWithValue }) => {
    try {
        const response = await InsuranceService.delete(id)
        const code = response.original.code;
        return {
            code: code,
            insurances : response.original.data
        };
    } catch (err) {
        return rejectWithValue({error : "Error deleting a Insurance"})
    }
})

export const InsuranceSlice = createSlice({
    name: 'insurances',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.fetching = !state.fetching
        },
        toggleInsuranceEditForm : (state) => {
            state.showEditForm =  !state.showEditForm;
        },
        toggleInsuranceNewForm : (state) => {
            state.showNewForm  = !state.showNewForm        
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInsurances.pending, (state) => {
                state.fetching = true
            })
            .addCase(fetchInsurances.fulfilled, (state, action) => {
                state.fetching = false
                state.list = action.payload.insurances
            })
            .addCase(fetchInsurances.rejected, (state, action) => {
                state.fetching = false
            })
            .addCase(createInsurance.pending, (state) => {
                state.creating = true
            })
            .addCase(createInsurance.fulfilled, (state, action) => {
                state.creating = false
                state.list = action.payload.insurances
                state.showNewForm = !state.showNewForm;
            })
            .addCase(createInsurance.rejected, (state, action) => {
                if(action.payload.code == 422){
                    state.errorMessages = formatValidationErrors(action.payload.error)
                }
                else {
                    // state.errorMessages = action.payload.error;
                }
                state.creating = false;
            })
            .addCase(updateInsurance.pending, (state, action) => {
                state.updating = true
            })
            .addCase(updateInsurance.fulfilled, (state, action) => {
                state.updating = false
                state.list = action.payload.insurances
                state.showEditForm = !state.showEditForm
            })
            .addCase(updateInsurance.rejected, (state, action) => {
                state.errorMessages = action.payload
                state.updating = false
            })
            .addCase(deleteInsurance.pending, (state, action) => {
                state.deleting = true
            })
            .addCase(deleteInsurance.fulfilled, (state, action) => {
                state.deleting = false
                state.list = action.payload.insurances
            })
            .addCase(deleteInsurance.rejected, (state, action) => {
                state.deleting = false
            })
    },
})

export const { 
    showLoading,
    toggleInsuranceEditForm,
    toggleInsuranceNewForm
} = InsuranceSlice.actions

export default InsuranceSlice.reducer